<template>
  <div class="pai">
    <div class="pai__head">
      <div class="pai__titles">
        <div class="pai__kicker">{{ $t('travelOffer.program') }}</div>
        <div class="pai__title">{{ programme.designation || "—" }}</div>
      </div>
      <button type="button" class="pai__delete" title="Retirer" @click="deleteItem">
        <v-icon small>mdi-trash-can-outline</v-icon>
      </button>
    </div>

    <div class="pai__times">
      <div class="pai__time">
        <div class="pai__label">{{ $t('travelOffer.departure') }}</div>
        <div class="pai__hour">{{ programme.heureDepart || "—" }}</div>
        <div class="pai__date">{{ programme.dateDepart || "—" }}</div>
      </div>
      <div class="pai__line"></div>
      <div class="pai__time pai__time--end">
        <div class="pai__label">{{ $t('travelOffer.arrival') }}</div>
        <div class="pai__hour">{{ programme.heureArrivee || "—" }}</div>
        <div class="pai__date">{{ programme.dateArrivee || "—" }}</div>
      </div>
    </div>

    <div class="pai__bus">
      <span>{{ $t('travelOffer.bus') }}</span>
      <strong>{{ programme.numeroBus || "—" }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgrammeAddedItem.vue",
  props: {
    programme: {
      type: Object,
      required: true,
    },

    deleteItem: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/admin/variables";

.pai {
  padding: 16px;
  background: #ffffff;
  border: 1px solid $ov-line;
  border-top: 3px solid $ov-green;
  border-radius: 12px;
  font-family: "Montserrat", sans-serif;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 10px 24px -12px rgba(12, 36, 97, 0.25);
  }
}

.pai__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.pai__titles {
  min-width: 0;
}

.pai__kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $ov-green;
}

.pai__title {
  font-size: 14px;
  font-weight: 800;
  color: $ov-navy;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pai__delete {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid $ov-line;
  border-radius: 8px;
  background: #ffffff;
  color: $ov-muted;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  .v-icon {
    color: inherit !important;
  }

  &:hover {
    color: $ov-danger;
    border-color: rgba(239, 68, 68, 0.4);
    background: rgba(239, 68, 68, 0.06);
  }
}

.pai__times {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0 14px;
}

.pai__time--end {
  text-align: right;
}

.pai__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: $ov-subtle;
}

.pai__hour {
  font-size: 18px;
  font-weight: 900;
  color: $ov-navy;
}

.pai__date {
  font-size: 12px;
  color: $ov-muted;
}

.pai__line {
  flex: 1;
  border-top: 2px dashed rgba(21, 158, 114, 0.45);
}

.pai__bus {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid $ov-line;
  font-size: 13px;
  color: $ov-muted;

  strong {
    color: $ov-ink;
  }
}
</style>
